module.exports = __webpack_public_path__ + "img/btn_bet_size.8721d1e8.png";